import { HomeScreen } from '@strata/react-page-templates';

import { StrataSuiteHomeSection } from 'components/home/StrataSuiteHomeSection';
import { SiteSections } from 'components/SiteSections';
import { AppRoutes } from 'services/routes';

export const StrataSuiteHomeScreen = () => (
    <HomeScreen
        illustration={HomeScreen.Illustration.STRATA}
        showTitle={false}
        button={{ label: 'Help Us Improve', path: AppRoutes.feedback }}
        welcomeMessagePartOne="The Strata Suite is a three part collection of resources that encompasses a holistic view of design at Free Market Health. If there is something you wish we would add or change, don't hesitate to reach out!"
        customContent={
            <div className="sds_suite-home__section">
                {SiteSections.map((section) => (
                    <StrataSuiteHomeSection
                        key={section.title}
                        title={section.title}
                        sectionHomeRoute={section.sectionHomeRoute}
                        image={section.image}
                        description={section.description}
                    />
                ))}
            </div>
        }
    />
);
